// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__HWK-f","label":"LabeledBox_label__1pGIT"};